import * as React from "react";
import { FramesBundleContentDescription } from "./FramesBundleContentDescription.js";
import { useFramesEcommContext } from "../../../../../../../context/modules/EcommContent/FramesEcommContent/context/FramesEcommContext.js";
const FramesBundleContentDescriptionContainer = ({ className }) => {
  const { selectedOffering } = useFramesEcommContext();
  if (!selectedOffering?.bundleContentDescription) return null;
  return /* @__PURE__ */ React.createElement(
    FramesBundleContentDescription,
    {
      description: selectedOffering.bundleContentDescription,
      className
    }
  );
};
export {
  FramesBundleContentDescriptionContainer
};
//# sourceMappingURL=FramesBundleContentDescriptionContainer.js.map
